<section class="messaging-page">
  <header class="messaging-toolbar">
    <div>
      <h1>{{ pageTitle }}</h1>
      <span>{{ pageDescription }}</span>
    </div>
  </header>

  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="stats-grid">
    <article class="stat-card">
      <span>Кампании</span>
      <strong>{{ campaigns.length }}</strong>
    </article>
    <article class="stat-card">
      <span>Планируются</span>
      <strong>{{ plannedCampaigns }}</strong>
    </article>
    <article class="stat-card">
      <span>Telegram аккаунты</span>
      <strong>{{ context.telegramAccounts.length }}</strong>
    </article>
  </section>

  <section class="list-panel mailings-list-panel" *ngIf="isListMode">
    <div class="panel-tools">
      <div>
        <h2>Очередь и история кампаний</h2>
        <span>{{ campaigns.length }} рассылок</span>
      </div>
      <div class="panel-actions">
        <button class="action-button ghost" type="button" (click)="runDispatchQueue()" [disabled]="dispatching">
          {{ dispatching ? 'Обрабатываем...' : 'Запустить очередь' }}
        </button>
        <a class="action-button panel-add-button" routerLink="/dashboard/mailings/new">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
          <span>Добавить</span>
        </a>
      </div>
    </div>

    <div class="empty-state" *ngIf="!loading && campaigns.length === 0">Рассылки пока не созданы.</div>

    <div class="mailing-list" *ngIf="campaigns.length > 0">
      <article
        class="mailing-row"
        *ngFor="let campaign of campaigns; trackBy: trackById"
        [routerLink]="['/dashboard/mailings', getCampaignRoute(campaign), 'edit']">
        <div class="mailing-main">
          <strong>{{ campaign.code }}</strong>
          <div>
            <b>{{ campaign.title }}</b>
            <span>{{ getSenderName(campaign) }} • {{ getAccountName(campaign) }}</span>
          </div>
        </div>
        <div class="mailing-message">
          <span>{{ campaign.messageTemplate }}</span>
          <small>{{ getAudienceLabel(campaign.audienceMode) }}</small>
        </div>
        <div class="mailing-meta">
          <span>{{ formatDate(campaign.scheduledAt) }}</span>
          <small>{{ campaign.minDelaySeconds }}-{{ campaign.maxDelaySeconds }} сек.</small>
        </div>
        <div class="mailing-teams">
          <span *ngIf="campaign.teams.length === 0">Все клиенты</span>
          <span class="chip" *ngFor="let team of campaign.teams.slice(0, 3); trackBy: trackById">{{ team.name }}</span>
          <span *ngIf="campaign.teams.length > 3">+{{ campaign.teams.length - 3 }}</span>
        </div>
        <div class="mailing-counters">
          <span>Всего {{ campaign.recipientCount }}</span>
          <span>В очереди {{ campaign.queuedCount }}</span>
          <span>Отправлено {{ campaign.sentCount }}</span>
          <span>Ошибки {{ campaign.failedCount }}</span>
        </div>
        <span class="status-pill" [ngClass]="getStatusClass(campaign)">{{ getStatusLabel(campaign.status) }}</span>
      </article>
    </div>
  </section>

  <section class="mailing-editor" *ngIf="!isListMode">
    <form class="editor-layout" (ngSubmit)="createCampaign()">
      <div class="editor-main">
        <section class="form-panel">
          <h2>{{ formTitle }}</h2>
          <div class="form-grid">
            <label class="wide">
              <span>Название</span>
              <input class="form-control" name="title" placeholder="Билеты на Авангард - Ак Барс" [(ngModel)]="formData.title" (ngModelChange)="preview = null">
            </label>

            <label>
              <span>Ответственный</span>
              <select class="form-control" name="senderUserId" [(ngModel)]="formData.senderUserId" (ngModelChange)="onSenderChange()">
                <option *ngFor="let user of context.users; trackBy: trackById" [value]="user.id">{{ user.displayName || user.username }}</option>
              </select>
            </label>

            <label>
              <span>Отправщик GramJS</span>
              <select class="form-control" name="telegramAccountId" [(ngModel)]="formData.telegramAccountId" (ngModelChange)="preview = null">
                <option value="" disabled>Выберите аккаунт</option>
                <option *ngFor="let account of filteredAccounts; trackBy: trackById" [value]="account.id">{{ account.label }} •••• {{ account.phoneLast4 }}</option>
              </select>
              <small *ngIf="filteredAccounts.length === 0">У выбранного ответственного нет авторизованного Telegram-аккаунта.</small>
            </label>

            <label>
              <span>Аудитория</span>
              <select class="form-control" name="audienceMode" [(ngModel)]="formData.audienceMode" (ngModelChange)="preview = null">
                <option *ngFor="let mode of audienceModes" [value]="mode.value">{{ mode.label }}</option>
              </select>
            </label>

            <div class="multi-select wide" *ngIf="formData.audienceMode === 'team_subscribers'">
              <span>Команды</span>
              <button class="select-trigger" type="button" (click)="toggleTeamsMenu()">{{ selectedTeamsText }}</button>
              <div class="select-menu" *ngIf="teamsMenuOpen">
                <button
                  class="team-option"
                  type="button"
                  *ngFor="let team of sortedTeams; trackBy: trackById"
                  [class.selected]="isTeamSelected(team.id)"
                  (click)="toggleTeam(team.id)">
                  <span>{{ team.championship }}</span>
                  <strong>{{ team.name }}</strong>
                  <i *ngIf="isTeamSelected(team.id)">Выбрано</i>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section class="form-panel">
          <h2>Сообщение</h2>
          <div class="form-grid">
            <label>
              <span>Режим картинки</span>
              <select class="form-control" name="imageMode" [(ngModel)]="formData.imageMode" (ngModelChange)="onImageModeChange()">
                <option *ngFor="let mode of imageModes" [value]="mode.value">{{ mode.label }}</option>
              </select>
              <small *ngIf="formData.imageMode !== 'none' && !formData.imageUrl">Сначала выберите файл картинки.</small>
            </label>

            <div class="file-field">
              <span>Картинка</span>
              <label class="file-trigger">
                <input type="file" accept="image/png,image/jpeg,image/webp,image/gif" (change)="uploadImage($event)">
                <span>{{ uploadingImage ? 'Загружаем...' : (formData.imageUrl ? 'Заменить картинку' : 'Выбрать файл') }}</span>
              </label>
            </div>

            <div class="image-attachment wide" *ngIf="formData.imageUrl">
              <img [src]="resolveImageUrl(formData.imageUrl)" alt="">
              <div>
                <strong>{{ uploadedImageName || 'Картинка рассылки' }}</strong>
                <small>{{ formData.imageUrl }}</small>
              </div>
              <button class="icon-button delete" type="button" title="Убрать картинку" aria-label="Убрать картинку" (click)="removeImage()">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
              </button>
            </div>

            <label class="wide">
              <span>Текст</span>
              <textarea class="form-control textarea" rows="7" name="messageTemplate" [(ngModel)]="formData.messageTemplate" (ngModelChange)="preview = null"></textarea>
              <small>Плейсхолдеры: {{ '{имя клиента}' }}, {{ '{имя}' }}, {{ '{{client_first_name}}' }}.</small>
            </label>
          </div>
        </section>

        <section class="preview-panel" *ngIf="preview">
          <header>
            <span>Получателей</span>
            <strong>{{ preview.recipientCount }}</strong>
          </header>
          <article *ngFor="let recipient of preview.sampleRecipients">
            <strong>{{ recipient.name }}</strong>
            <small>Telegram ID {{ recipient.telegramId }}</small>
            <p>{{ recipient.renderedMessage }}</p>
          </article>
        </section>
      </div>

      <aside class="editor-side">
        <section class="form-panel">
          <h2>Отправка</h2>
          <label class="switch-row">
            <span>Отправить сразу</span>
            <input type="checkbox" name="sendNow" [(ngModel)]="formData.sendNow" (ngModelChange)="preview = null">
            <i></i>
          </label>

          <label *ngIf="!formData.sendNow">
            <span>Дата отправки</span>
            <input class="form-control" type="datetime-local" name="scheduledAt" [(ngModel)]="formData.scheduledAt" (ngModelChange)="preview = null">
          </label>

          <div class="delay-grid">
            <label>
              <span>Задержка от</span>
              <input class="form-control" type="number" min="0" name="minDelaySeconds" [(ngModel)]="formData.minDelaySeconds">
            </label>
            <label>
              <span>Задержка до</span>
              <input class="form-control" type="number" min="0" name="maxDelaySeconds" [(ngModel)]="formData.maxDelaySeconds">
            </label>
          </div>
        </section>

        <section class="form-panel actions-panel">
          <h2>Действия</h2>
          <button class="action-button ghost" type="button" (click)="previewCampaign()" [disabled]="previewing">
            {{ previewing ? 'Считаем...' : 'Посчитать получателей' }}
          </button>
          <button class="action-button primary" type="submit" [disabled]="saving || uploadingImage">{{ submitButtonLabel }}</button>
          <button class="action-button danger" type="button" *ngIf="isEditMode" [disabled]="!canDeleteEditingCampaign || saving" (click)="deleteCampaign()">Удалить рассылку</button>
          <a class="action-button ghost" routerLink="/dashboard/mailings">Назад к списку</a>
        </section>
      </aside>
    </form>
  </section>
</section>
